<template>
  <div class="profile-page pk-account-panel">
    <section v-if="!loggedIn" class="profile-auth-card">
      <div class="profile-auth-copy">
        <span>个人账户</span>
        <strong>登录后管理你的账号资料</strong>
        <p>个人资料、交易链接、邀请关系和账号安全均与当前账户关联。未登录时不会展示可编辑的资料表单。</p>
        <button @click="openLogin">登录 / 注册</button>
      </div>
      <div class="profile-auth-visual">
        <img :src="guestVisual" alt="" />
      </div>
    </section>

    <template v-else>
      <section class="profile-hero">
        <div class="profile-card">
          <div class="avatar-wrap">
            <img :src="Data.img || defaultAvatar" alt="" @error="useAvatarFallback" />
            <el-upload
              class="avatar-upload"
              action="/"
              :limit="1"
              :auto-upload="false"
              :on-change="handleChange"
            >
              <button>更换头像</button>
            </el-upload>
          </div>
          <div class="profile-main">
            <span>账号</span>
            <h1>{{ Data.name || Data.mobile }}</h1>
            <div class="profile-tags">
              <em>UID {{ Data.id }}</em>
              <em>VIP {{ Data.grade || 0 }}</em>
              <em>{{ Data.mobile }}</em>
              <em v-if="Data.invite_code">CODE {{ Data.invite_code }}</em>
              <em>{{ Data.invite_rate || 0 }}%</em>
            </div>
            <div class="profile-actions">
              <button @click="getName">修改昵称</button>
              <button class="ghost" @click="copyText(Data.id)">复制 UID</button>
            </div>
          </div>
        </div>
        <div class="login-card">
          <span>最近登录</span>
          <strong>{{ site || "本地" }}</strong>
          <em>{{ time || "-" }}</em>
        </div>
      </section>

      <section class="asset-grid">
        <article class="currency-card pizza" title="披萨币：充值获取，用于打开箱子、拉货、箱子战斗和站内正常玩法" aria-label="披萨币余额">
          <i aria-hidden="true"></i>
          <strong>{{ moneyText(Data.total_amount) }}</strong>
        </article>
        <article class="currency-card wheat" title="小麦币：饰品兑换自动获得，用于小麦商城，也可在转换页兑换为披萨币" aria-label="小麦币余额，进入转换页" role="button" tabindex="0" @click="goCurrencyExchange" @keyup.enter="goCurrencyExchange">
          <i aria-hidden="true"></i>
          <strong>{{ moneyText(Data.masonry) }}</strong>
          <em class="currency-action">转换</em>
        </article>
        <article class="currency-card cheese" title="奶酪币：活动或任务获取，用于特殊箱子和专属币种玩法" aria-label="奶酪币余额">
          <i aria-hidden="true"></i>
          <strong>{{ moneyText(Data.cheese_coin) }}</strong>
        </article>
        <article class="currency-card key" title="特殊钥匙：用于开启对应特殊箱子" aria-label="特殊钥匙数量">
          <i aria-hidden="true"></i>
          <strong>{{ specialKeyBalance }}</strong>
        </article>
      </section>

      <section class="settings-grid">
        <article class="setting-panel trade-panel">
          <div class="panel-head">
            <span>发货资料</span>
            <strong>交易链接</strong>
            <em>交易资料将用于账号验证和人工取回审核。</em>
          </div>
          <div class="trade-input">
            <input
              v-model.trim="url"
              type="url"
              :disabled="tradeUrlBound"
              autocomplete="off"
              placeholder="请输入 Steam 饰品取回链接"
            />
            <button v-if="!tradeUrlBound" @click="bindTradeUrl">首次绑定</button>
          </div>
          <p v-if="tradeUrlBound">交易链接已绑定。如需更正，请联系站内客服，由后台管理员修改。</p>
          <p v-else>请核对链接后再绑定。首次绑定成功后，前端不能自行修改。</p>
        </article>

        <article class="setting-panel">
          <div class="panel-head">
            <span>邀请关系</span>
            <strong>邀请关系</strong>
          </div>
          <div v-if="inviteName || inviteImg" class="inviter">
            <img :src="inviteImg || defaultAvatar" alt="" @error="useAvatarFallback" />
            <div>
              <strong>{{ inviteName || "已绑定上级" }}</strong>
              <em>当前账号已有邀请关系</em>
            </div>
          </div>
          <div v-else class="bind-box">
            <p>新用户可在有效期内绑定上级邀请码。</p>
            <button @click="openTop">绑定上级</button>
          </div>
        </article>

        <article class="setting-panel">
          <div class="panel-head">
            <span>账号安全</span>
            <strong>账号管理</strong>
          </div>
          <div class="account-row">
            <span>手机号</span>
            <strong>{{ Data.mobile }}</strong>
          </div>
          <div class="account-row">
            <span>邮箱</span>
            <strong>{{ Data.email || "未绑定" }}</strong>
            <button @click="openEmail">绑定</button>
          </div>
          <div class="account-row">
            <span>密码</span>
            <strong>已启用</strong>
            <button @click="openPass">修改</button>
          </div>
        </article>

        <article class="setting-panel">
          <div class="panel-head">
            <span>偏好设置</span>
            <strong>偏好设置</strong>
            <em>当前仅前端展示，不写入缺失字段。</em>
          </div>
          <label class="toggle-row">
            <el-checkbox v-model="checked1" @change="savePreferences">开启声音效果</el-checkbox>
          </label>
          <label class="toggle-row">
            <el-checkbox v-model="checked2" @change="savePreferences">活动结果浏览器提醒</el-checkbox>
          </label>
          <label class="toggle-row">
            <el-checkbox v-model="checked3" @change="savePreferences">短信提醒</el-checkbox>
            <small>仅用于账号、取回和活动结果提醒；实际发送仍以后台短信模板和用户授权为准。</small>
          </label>
        </article>
      </section>
    </template>
  </div>
</template>

<script>
import Utils from "./../assets/js/util.js";

export default {
  inject: ["reload"],
  props: ["yidongmenu", "showNav", "openHongbao"],
  data() {
    return {
      Data: {},
      site: "",
      time: "",
      url: "",
      tradeUrlBound: false,
      inviteImg: "",
      inviteName: "",
      checked1: false,
      checked2: false,
      checked3: false,
      specialKeyBalance: 0,
      defaultAvatar: require("../assets/img/jiapeople.png"),
      guestVisual: require("../assets/pizzaking/icon-account-guest.svg"),
    };
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token || localStorage.getItem("token"));
    },
  },
  watch: {
    loggedIn(value) {
      if (value) {
        this.getList();
        this.getSpecialKeys();
      } else {
        this.Data = {};
        this.site = "";
        this.time = "";
        this.url = "";
        this.tradeUrlBound = false;
        this.inviteImg = "";
        this.inviteName = "";
        this.specialKeyBalance = 0;
      }
    },
  },
  mounted() {
    this.loadPreferences();
    if (this.loggedIn) {
      this.getList();
      this.getSpecialKeys();
    }
  },
  methods: {
    goCurrencyExchange() {
      this.$router.push("/CurrencyExchange");
    },
    loadPreferences() {
      const storedSoundEnabled = localStorage.getItem("pizzaking-sound-enabled");
      this.checked1 = storedSoundEnabled === null || storedSoundEnabled !== "0";
      const raw = localStorage.getItem("pizzaking-notice-preferences");
      if (!raw) return;
      try {
        const preferences = JSON.parse(raw);
        if (storedSoundEnabled === null && typeof preferences.sound === "boolean") {
          this.checked1 = preferences.sound;
        }
        this.checked2 = Boolean(preferences.browser);
        this.checked3 = Boolean(preferences.sms);
      } catch (error) {
        localStorage.removeItem("pizzaking-notice-preferences");
      }
    },
    savePreferences() {
      localStorage.setItem("pizzaking-notice-preferences", JSON.stringify({
        sound: this.checked1,
        browser: this.checked2,
        sms: this.checked3,
      }));
      localStorage.setItem("pizzaking-sound-enabled", this.checked1 ? "1" : "0");
      this.$root.$emit("sound-state-change", this.checked1);
      this.$message.success("提醒偏好已保存");
    },
    openLogin() {
      this.$store.commit("getLogin", true);
    },
    getList() {
      this.$axios.post("/index/User/playerInfo", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.Data = res.data.data;
          this.url = this.Data.tradeUrl;
          this.tradeUrlBound = Boolean(this.Data.tradeUrl);
          this.site = this.Data.last_login_info.position;
          this.time = this.Data.last_login_info.time;
          if (this.Data.myInviter) {
            this.inviteImg = this.Data.myInviter.img;
            this.inviteName = this.Data.myInviter.name;
          }
        }
      });
    },
    getSpecialKeys() {
      this.$axios.post("/index/special_key/myKeys", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.specialKeyBalance = (res.data.data || []).reduce((total, item) => total + Number(item.quantity || 0), 0);
        }
      });
    },
    bindTradeUrl() {
      if (!this.url) {
        this.$message({ message: "请输入 Steam 饰品取回链接", type: "info" });
        return;
      }
      this.$confirm("交易链接首次绑定后只能由后台管理员修改，确认绑定当前链接？", "确认绑定", {
        confirmButtonText: "确认绑定",
        cancelButtonText: "再检查一下",
        type: "warning",
      }).then(() => {
        this.$axios.post("/index/User/bindSteamnew", this.$qs.stringify({ tradeUrl: this.url })).then((res) => {
          if (res.data.status == 1) {
            this.tradeUrlBound = true;
            this.Data.tradeUrl = this.url;
            this.$message({ message: "交易链接绑定成功", type: "success" });
          } else {
            this.$message({ message: res.data.msg || "绑定失败", type: "info" });
          }
        });
      });
    },
    syncUserInfo(data) {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      Object.assign(userInfo, data);
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      Utils.$emit("login", userInfo);
    },
    handleChange(file) {
      const formData = new FormData();
      formData.append("player_id", this.$store.state.id);
      formData.append("file", file.raw);
      this.$axios({
        url: "/index/User/editHeadImage",
        method: "post",
        dataType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        if (res.data.status == 1) {
          this.Data.img = res.data.data;
          Utils.$emit("img", this.Data.img);
          this.reload();
        }
      });
    },
    getName() {
      this.$prompt("请输入新的昵称", "昵称修改", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        this.$axios
          .post("/index/User/editNickname", this.$qs.stringify({ name: value }))
          .then((res) => {
            if (res.data.status == 1) {
              this.Data.name = value;
              this.syncUserInfo({ name: value });
              this.$message({ message: "修改成功", type: "success" });
            } else {
              this.$message({ message: res.data.msg || "修改失败", type: "info" });
            }
          });
      });
    },
    openEmail() {
      this.$prompt("请输入邮箱", "邮箱绑定", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: "邮箱格式不正确",
      }).then(({ value }) => {
        this.$axios.post("/index/User/bindEmail", this.$qs.stringify({ email: value })).then((res) => {
          if (res.data.status == 1) {
            this.Data.email = value;
            this.syncUserInfo({ email: value });
            this.$message({ message: "绑定成功", type: "success" });
          } else {
            this.$message({ message: res.data.msg || "绑定失败", type: "info" });
          }
        });
      });
    },
    openPass() {
      this.$prompt("请输入新密码", "密码修改", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        this.$axios.post("/index/User/editPass", this.$qs.stringify({ password: value })).then((res) => {
          this.$message({
            message: res.data.status == 1 ? "修改成功" : res.data.msg || "修改失败",
            type: res.data.status == 1 ? "success" : "info",
          });
        });
      });
    },
    openTop() {
      this.$prompt("请输入邀请码", "绑定上级", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        this.$axios
          .post("index/User/bindInviter", this.$qs.stringify({ invite_code: value }))
          .then((res) => {
            if (res.data.status == 1) {
              this.$message({ message: "绑定成功", type: "success" });
              this.getList();
            } else {
              this.$message({ message: `绑定失败：${res.data.msg}`, type: "info" });
            }
          });
      });
    },
    copyText(text) {
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message({ message: "复制成功", type: "success" });
    },
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
    useAvatarFallback(event) {
      event.target.src = this.defaultAvatar;
    },
  },
};
</script>

<style lang="less" scoped>
.profile-page {
  min-height: calc(100vh - 198px);
  padding: 26px 26px 74px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 44% 0, rgba(255, 138, 31, 0.16), transparent 34%),
    radial-gradient(circle at 86% 24%, rgba(0, 217, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #1d202c 0%, #171923 100%);
}

button {
  font-family: inherit;
}

.profile-auth-card,
.profile-hero,
.asset-grid,
.settings-grid {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.profile-auth-card {
  min-height: 360px;
  padding: 44px 54px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 28px;
  align-items: center;
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(135deg, rgba(43, 45, 59, 0.96), rgba(24, 26, 36, 0.98)),
    radial-gradient(circle at 82% 42%, rgba(255, 138, 31, 0.24), transparent 43%);
  border: 1px solid rgba(255, 132, 31, 0.34);
  border-radius: 18px;
  box-shadow: 0 28px 90px rgba(0, 0, 0, 0.36), inset 0 1px 0 rgba(255, 224, 170, 0.08);
}

.profile-auth-card::before {
  content: "";
  width: 640px;
  height: 280px;
  position: absolute;
  right: -90px;
  bottom: -126px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 190, 67, 0.28), transparent 68%);
}

.profile-auth-copy,
.profile-auth-visual {
  position: relative;
  z-index: 1;
}

.profile-auth-copy span {
  color: #ff8a1f;
  font-size: 13px;
  font-weight: 1000;
  letter-spacing: 0.16em;
}

.profile-auth-copy strong {
  display: block;
  margin-top: 12px;
  color: #f8fbff;
  font-size: 38px;
  line-height: 1.14;
  font-weight: 1000;
}

.profile-auth-copy p {
  max-width: 680px;
  margin: 14px 0 22px;
  color: #aeb6c8;
  font-size: 15px;
  line-height: 1.8;
}

.profile-auth-card button {
  height: 44px;
  padding: 0 22px;
  color: #151620;
  background: linear-gradient(180deg, #ffcb28, #ff8a00);
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 1000;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(241, 107, 0, 0.25);
}

.profile-auth-visual {
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-auth-visual img {
  width: 174px;
  height: 174px;
  object-fit: cover;
  border: 1px solid rgba(255, 163, 35, 0.34);
  border-radius: 26px;
  background: #242735;
  box-shadow:
    0 24px 46px rgba(0, 0, 0, 0.35),
    0 0 38px rgba(255, 138, 0, 0.18);
}

.profile-hero {
  display: grid;
  grid-template-columns: 1fr 310px;
  gap: 16px;
}

.profile-card,
.login-card,
.asset-grid article,
.setting-panel {
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.profile-card {
  min-height: 288px;
  padding: 36px;
  display: grid;
  grid-template-columns: 166px 1fr;
  gap: 30px;
  align-items: center;
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(135deg, rgba(39, 42, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
}

.profile-card::after {
  content: "";
  width: 520px;
  height: 520px;
  position: absolute;
  right: -160px;
  top: -180px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 147, 31, 0.3), transparent 66%);
}

.avatar-wrap,
.profile-main {
  position: relative;
  z-index: 1;
}

.avatar-wrap {
  width: 166px;
  height: 166px;
  overflow: hidden;
  border: 1px solid rgba(255, 163, 35, 0.34);
  border-radius: 22px;
  background: #242735;
  box-shadow: 0 22px 45px rgba(0, 0, 0, 0.3);
}

.avatar-wrap > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-upload {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

.avatar-upload /deep/ .el-upload {
  width: 100%;
}

.avatar-upload button {
  width: 100%;
  height: 34px;
  color: #151620;
  background: linear-gradient(180deg, #ffcb28, #ff8a00);
  border: 0;
  font-size: 13px;
  font-weight: 1000;
  cursor: pointer;
}

.profile-main > span,
.login-card span,
.panel-head span {
  color: #ff8a1f;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.16em;
}

.profile-main h1 {
  margin: 12px 0 14px;
  color: #f8fbff;
  font-size: 46px;
  line-height: 1.06;
  font-weight: 1000;
}

.profile-tags,
.profile-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.profile-tags em {
  padding: 8px 12px;
  color: #aeb7ca;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 999px;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
}

.profile-actions {
  margin-top: 24px;
}

.profile-actions button,
.trade-input button,
.bind-box button,
.account-row button {
  height: 42px;
  padding: 0 20px;
  color: #151620;
  background: linear-gradient(180deg, #ffcb28, #ff8a00);
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 1000;
  cursor: pointer;
}

.profile-actions .ghost,
.trade-input .ghost {
  color: #f4f7ff;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.login-card {
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-card strong {
  margin-top: 16px;
  color: #f8fbff;
  font-size: 30px;
  font-weight: 1000;
}

.login-card em {
  margin-top: 10px;
  color: #9aa3b8;
  font-style: normal;
  font-weight: 900;
}

.asset-grid {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.asset-grid article {
  min-height: 104px;
  padding: 20px 22px;
}

.asset-grid strong {
  color: #f8fbff;
  font-size: 25px;
  font-weight: 1000;
}

.asset-grid .currency-card {
  display: flex;
  align-items: center;
  gap: 14px;
  position: relative;
  overflow: hidden;
}

.asset-grid .currency-card::after {
  content: "";
  width: 92px;
  height: 92px;
  position: absolute;
  right: -28px;
  bottom: -44px;
  border-radius: 50%;
  background: var(--currency-glow);
  filter: blur(14px);
  opacity: 0.34;
}

.asset-grid .currency-card i {
  width: 34px;
  height: 34px;
  display: block;
  flex: 0 0 34px;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
  filter: drop-shadow(0 0 10px rgba(255, 137, 26, 0.3));
}

.asset-grid .currency-card.pizza { --currency-glow: #ff8a1f; }
.asset-grid .currency-card.wheat { --currency-glow: #f3c94b; }
.asset-grid .currency-card.cheese { --currency-glow: #ffd95d; }
.asset-grid .currency-card.key { --currency-glow: #46d9bb; }
.asset-grid .currency-card.wheat i { background-image: url("../assets/pizzaking/wheat-token.svg"); }
.asset-grid .currency-card.cheese i { background-image: url("../assets/pizzaking/cheese-token.svg"); }
.asset-grid .currency-card.key i { background-image: url("../assets/pizzaking/special-key-token.svg"); }
.asset-grid .currency-card.wheat strong { color: #f7d66c; }
.asset-grid .currency-card.cheese strong { color: #ffe08a; }
.asset-grid .currency-card.key strong { color: #83ead3; }

.asset-grid .currency-card.wheat {
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.asset-grid .currency-card.wheat:hover,
.asset-grid .currency-card.wheat:focus {
  border-color: rgba(247, 214, 108, 0.55);
  outline: 0;
  transform: translateY(-2px);
}

.currency-action {
  margin-left: auto;
  position: relative;
  z-index: 1;
  color: #f7d66c;
  font-size: 12px;
  font-style: normal;
  font-weight: 900;
}

.settings-grid {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.setting-panel {
  padding: 22px;
}

.panel-head strong {
  display: block;
  margin-top: 9px;
  color: #f4f7ff;
  font-size: 22px;
  font-weight: 1000;
}

.panel-head em,
.setting-panel p {
  display: block;
  margin-top: 8px;
  color: #9aa3b8;
  font-size: 13px;
  line-height: 1.65;
  font-style: normal;
}

.trade-input {
  margin-top: 18px;
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 10px;
}

.trade-input input {
  height: 42px;
  padding: 0 14px;
  color: #f4f7ff;
  background: #1c1e28;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  outline: none;
}

.inviter,
.bind-box,
.account-row,
.toggle-row {
  margin-top: 16px;
  padding: 14px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 10px;
}

.inviter {
  display: flex;
  align-items: center;
  gap: 14px;
}

.inviter img {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  object-fit: cover;
}

.inviter strong,
.account-row strong {
  color: #f4f7ff;
  font-size: 15px;
  font-weight: 1000;
}

.inviter em {
  display: block;
  margin-top: 6px;
  color: #9aa3b8;
  font-size: 13px;
  font-style: normal;
}

.bind-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.account-row {
  display: grid;
  grid-template-columns: 94px 1fr auto;
  align-items: center;
  gap: 12px;
}

.account-row span {
  color: #9aa3b8;
  font-weight: 900;
}

.account-row button {
  height: 34px;
  padding: 0 14px;
}

.toggle-row {
  display: block;
}

.toggle-row /deep/ .el-checkbox {
  color: #dce3f4;
  font-weight: 900;
}

@media screen and (max-width: 1040px) {
  .profile-auth-card,
  .profile-hero,
  .asset-grid,
  .settings-grid {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 760px) {
  .profile-page {
    padding: 18px 12px 58px;
  }

  .profile-card,
  .profile-auth-card,
  .trade-input,
  .account-row {
    grid-template-columns: 1fr;
  }

  .profile-card {
    padding: 24px;
  }

  .profile-main h1 {
    font-size: 34px;
  }
}
</style>

<style lang="less">
.profile-page.pk-account-panel {
  padding: 32px 28px 96px !important;
}

.profile-page.pk-account-panel .profile-hero,
.profile-page.pk-account-panel .profile-auth-card,
.profile-page.pk-account-panel .asset-grid,
.profile-page.pk-account-panel .settings-grid {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.profile-page.pk-account-panel .profile-hero {
  grid-template-columns: minmax(0, 1fr) 338px !important;
  gap: 18px !important;
}

.profile-page.pk-account-panel .profile-card {
  min-height: 314px !important;
  border-color: rgba(255, 132, 31, 0.34) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.36),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.profile-page.pk-account-panel .avatar-wrap {
  width: 184px !important;
  height: 184px !important;
}

.profile-page.pk-account-panel .profile-main h1 {
  font-size: 54px !important;
}

.profile-page.pk-account-panel .login-card {
  border-color: rgba(111, 121, 151, 0.24) !important;
}

.profile-page.pk-account-panel .asset-grid article {
  min-height: 116px !important;
}

.profile-page.pk-account-panel .settings-grid {
  grid-template-columns: 1.1fr 0.9fr !important;
  gap: 16px !important;
}

.profile-page.pk-account-panel .setting-panel {
  border-color: rgba(111, 121, 151, 0.22) !important;
}

@media screen and (max-width: 1040px) {
  .profile-page.pk-account-panel {
    padding: 18px 12px 58px !important;
  }

  .profile-page.pk-account-panel .profile-hero,
  .profile-page.pk-account-panel .profile-auth-card,
  .profile-page.pk-account-panel .asset-grid,
  .profile-page.pk-account-panel .settings-grid {
    width: 100% !important;
    grid-template-columns: 1fr !important;
  }

  .profile-page.pk-account-panel .profile-main h1 {
    font-size: 38px !important;
  }
}

/* 2026-07-05 exact internal pass: profile/account settings panels. */
.profile-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 96px !important;
  background:
    radial-gradient(ellipse at 50% 170px, rgba(255, 138, 31, 0.08), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 420px, #171923 100%) !important;
}

.profile-page.pk-account-panel .profile-hero,
.profile-page.pk-account-panel .profile-auth-card,
.profile-page.pk-account-panel .asset-grid,
.profile-page.pk-account-panel .settings-grid {
  width: 100% !important;
  max-width: none !important;
}

.profile-page.pk-account-panel .profile-hero {
  grid-template-columns: minmax(0, 1fr) 320px !important;
  gap: 12px !important;
}

.profile-page.pk-account-panel .profile-card,
.profile-page.pk-account-panel .login-card,
.profile-page.pk-account-panel .setting-panel,
.profile-page.pk-account-panel .asset-grid article {
  border-color: #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
  box-shadow: none !important;
}

.profile-page.pk-account-panel .profile-card {
  min-height: 286px !important;
  padding: 30px 36px !important;
}

.profile-page.pk-account-panel .profile-main h1 {
  color: #f4ead8 !important;
  font-size: 48px !important;
}

.profile-page.pk-account-panel .avatar-wrap {
  width: 164px !important;
  height: 164px !important;
  border-color: rgba(236, 216, 184, 0.28) !important;
}

.profile-page.pk-account-panel .settings-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 12px !important;
}

@media screen and (max-width: 760px) {
  .profile-page.pk-account-panel {
    width: 100% !important;
    max-width: 100vw !important;
    min-height: 100dvh !important;
    padding: 14px 12px calc(118px + env(safe-area-inset-bottom)) !important;
    box-sizing: border-box !important;
    overflow-x: hidden !important;
  }

  .profile-page.pk-account-panel *,
  .profile-page.pk-account-panel *::before,
  .profile-page.pk-account-panel *::after {
    box-sizing: border-box;
  }

  .profile-page.pk-account-panel .profile-hero,
  .profile-page.pk-account-panel .profile-auth-card,
  .profile-page.pk-account-panel .asset-grid,
  .profile-page.pk-account-panel .settings-grid {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  .profile-page.pk-account-panel .profile-hero,
  .profile-page.pk-account-panel .settings-grid {
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 12px !important;
  }

  .profile-page.pk-account-panel .profile-card {
    min-width: 0 !important;
    min-height: 0 !important;
    padding: 18px !important;
    grid-template-columns: 96px minmax(0, 1fr) !important;
    gap: 16px !important;
    align-items: start !important;
  }

  .profile-page.pk-account-panel .profile-card::after {
    width: 260px;
    height: 260px;
    right: -150px;
    top: -140px;
  }

  .profile-page.pk-account-panel .avatar-wrap {
    width: 96px !important;
    height: 116px !important;
    border-radius: 12px !important;
  }

  .profile-page.pk-account-panel .avatar-upload button {
    min-height: 44px;
    font-size: 12px;
  }

  .profile-page.pk-account-panel .profile-main {
    min-width: 0;
  }

  .profile-page.pk-account-panel .profile-main h1 {
    margin: 8px 0 12px !important;
    font-size: 26px !important;
    line-height: 1.2 !important;
    overflow-wrap: anywhere;
  }

  .profile-page.pk-account-panel .profile-main > span,
  .profile-page.pk-account-panel .login-card span,
  .profile-page.pk-account-panel .panel-head span {
    font-size: 12px;
    letter-spacing: 0.08em;
  }

  .profile-page.pk-account-panel .profile-tags {
    gap: 7px;
  }

  .profile-page.pk-account-panel .profile-tags em {
    max-width: 100%;
    padding: 6px 8px;
    font-size: 11px;
    overflow-wrap: anywhere;
  }

  .profile-page.pk-account-panel .profile-actions {
    margin-top: 14px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .profile-page.pk-account-panel .profile-actions button,
  .profile-page.pk-account-panel .trade-input button,
  .profile-page.pk-account-panel .bind-box button,
  .profile-page.pk-account-panel .account-row button {
    width: 100%;
    min-width: 0;
    height: 44px;
    padding: 0 10px;
    white-space: nowrap;
  }

  .profile-page.pk-account-panel .login-card,
  .profile-page.pk-account-panel .setting-panel {
    min-width: 0;
    padding: 18px !important;
  }

  .profile-page.pk-account-panel .login-card strong {
    margin-top: 10px;
    font-size: 22px;
    overflow-wrap: anywhere;
  }

  .profile-page.pk-account-panel .login-card em {
    overflow-wrap: anywhere;
  }

  .profile-page.pk-account-panel .asset-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
  }

  .profile-page.pk-account-panel .asset-grid article {
    min-width: 0;
    min-height: 86px !important;
    padding: 14px !important;
  }

  .profile-page.pk-account-panel .asset-grid strong {
    min-width: 0;
    font-size: 18px;
    overflow-wrap: anywhere;
  }

  .profile-page.pk-account-panel .asset-grid .currency-card {
    gap: 10px;
  }

  .profile-page.pk-account-panel .asset-grid .currency-card i {
    width: 28px;
    height: 28px;
    flex-basis: 28px;
  }

  .profile-page.pk-account-panel .trade-input {
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 10px;
  }

  .profile-page.pk-account-panel .trade-input input {
    width: 100%;
    min-width: 0;
    height: 46px;
    font-size: 14px;
  }

  .profile-page.pk-account-panel .bind-box {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  .profile-page.pk-account-panel .account-row {
    grid-template-columns: 54px minmax(0, 1fr) 58px !important;
    gap: 6px;
  }

  .profile-page.pk-account-panel .account-row strong {
    min-width: 0;
    font-size: 13px;
    overflow-wrap: anywhere;
  }

  .profile-page.pk-account-panel .account-row button {
    width: auto;
    min-width: 62px;
  }

  .profile-page.pk-account-panel .toggle-row,
  .profile-page.pk-account-panel .inviter,
  .profile-page.pk-account-panel .bind-box,
  .profile-page.pk-account-panel .account-row {
    max-width: 100%;
  }

  .el-message-box {
    width: calc(100vw - 24px) !important;
    max-width: 420px !important;
  }
}
</style>
